export default __webpack_public_path__ + "static/belloffice-3e5b2bdcff69424c388c87816eb59ccc.png";